import { WEB_APPS_LIST_BY_NAME } from "../../modules/AppWrapper2/types.js";
// src/utils/URL-ops/make-ops-event-URL.ts
var OPS_EVENT_PATH = `${WEB_APPS_LIST_BY_NAME.OPS.link}/events/view/:eventId`;
function makeOpsEventURL(eventId) {
	if (!eventId) console.warn("makeOpsEventURL: no eventId provided");
	return OPS_EVENT_PATH.replace(":eventId", eventId);
}
export { makeOpsEventURL };

//# sourceMappingURL=make-ops-event-URL.js.map